import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { HttpService } from "./http.service";

// Technically these should match the keys for `this.changedFilters` inside of filter-bar
// A typing for another day
export type FilterJson = {
    departments?: string;
    classifications?: string;
    "insurance-statuses"?: string;
    coverages?: string;
    "push-notification-types"?: string;
    accounts?: string;
    search?: string;
    "loan-balance-min"?: string;
    "loan-balance-max"?: string;
    "loan-state"?: string;
    "issue-date"?: string;
    "secondary-date"?: string;
    conditions?: string;
    "program-types"?: string;
    icl?: string;
    watchlist?: string;
};

export type Filter = {
    filterId: number;
    filterTypeId: number;
    name: string;
    filterJson: string | FilterJson;
    createdAt: string | Date;
};

export type IUpdateFilterPayload = {
    name: string;
    filterJson: string;
};

@Injectable()
export class FilterService extends HttpService {
    constructor(http: HttpClient, authService: AuthService) {
        super("FilterService", http, authService);
    }

    getFilters(type = "loan") {
        return this.get<Filter[]>(`filters/${type}`).pipe(
            map((res) => res.map((elem) => this._mapFilter(elem)))
        );
    }

    updateFilter(id: number, payload: IUpdateFilterPayload) {
        return this.put<Filter>(`filters/${id}`, payload).pipe(
            map((res: Filter) => this._mapFilter(res))
        );
    }

    saveFilter(payload: IUpdateFilterPayload): Observable<Filter> {
        return this.post<Filter>("filters/loan", payload).pipe(
            map((res: Filter) => this._mapFilter(res))
        );
    }

    deleteFilter = (filter: Filter) =>
        this.delete(`filters/${filter.filterId}`);

    private _mapFilter(f: Filter): Filter {
        const temp = { ...f };

        temp.createdAt = new Date(f.createdAt);

        try {
            temp.filterJson = JSON.parse(f.filterJson as string);
        } catch (e) {
            temp.filterJson = { departments: "consumer,commercial" };
        }

        return temp;
    }
}
